/**
 * Componente de protección de rutas para administradores
 * Redirige a "/" si el usuario no es administrador
 */

import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

export default function AdminProtectedRoute({ children }: AdminProtectedRouteProps) {
  const [hasCheckedRole, setHasCheckedRole] = useState(false);
  const { user, loading } = useAuth();

  // Marcar que ya se verificó el rol una vez que termine de cargar
  useEffect(() => {
    if (!loading) {
      setHasCheckedRole(true);
    }
  }, [loading]);

  // Debug
  console.log('🔍 AdminProtectedRoute Debug:');
  console.log('  - user:', user?.email);
  console.log('  - isAdmin:', user?.es_admin);
  console.log('  - loading:', loading);
  console.log('  - hasCheckedRole:', hasCheckedRole);
  console.log('  - Decisión:', 
    loading || !hasCheckedRole ? 'MOSTRAR LOADER' :
    !user ? 'REDIRIGIR A LOGIN' :
    !user.es_admin ? 'REDIRIGIR A INICIO (NO ES ADMIN)' :
    'MOSTRAR CONTENIDO'
  );

  // Mostrar loader mientras se verifica
  if (loading || !hasCheckedRole) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          gap: 2,
        }}
      >
        <CircularProgress size={60} />
        <Box sx={{ textAlign: 'center' }}>
          Verificando permisos...
        </Box>
      </Box>
    );
  }

  // Si no está autenticado, redirigir a login
  if (!user && hasCheckedRole) {
    return <Navigate to="/login" replace />;
  }

  // Si no es admin, mostrar mensaje y redirigir
  if (!user?.es_admin && hasCheckedRole) {
    return <Navigate to="/" replace />;
  }

  // Si es admin, mostrar el contenido
  return <>{children}</>;
}
